module.exports = __webpack_public_path__ + "static/media/userblock1.e2dc7a7f.svg";